import React from "react";
import Grid from "@material-ui/core/Grid";
import { Page, Icon, Card, Text } from "@shopify/polaris";
import { DomainIcon, ChartVerticalFilledIcon } from "@shopify/polaris-icons";
import { useNavigate } from "react-router-dom";
import { accessSettings } from "../../Helpers";

const GridView = () => {
  const navigate = useNavigate();

  return (
    accessSettings() && (
      <Page>
        <Card>
          <div style={{ padding: 20 }}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <div
                  style={{
                    padding: 10,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  className="gridItem"
                  onMouseDown={(e) =>
                    navigate("/admin/settings/integrations/shopify-domain")
                  }
                >
                  <div className="iconDiv">
                    <Icon
                      source={DomainIcon}
                      style={{ margin: "0 5px" }}
                      color="subdued"
                    ></Icon>
                  </div>
                  <div style={{ flexDirection: "column", marginLeft: "10" }}>
                    <div className="titleDev">
                      <Text variant="bodyMd" as="p" fontWeight="regular">
                        Shopify Domain
                      </Text>
                    </div>
                    <div className="description">
                      {/* <Text variant="bodyMd" as="p" fontWeight="regular">
                      SEO Image
                    </Text> */}
                    </div>
                  </div>
                </div>
              </Grid>

              <Grid item xs={4}>
                <div
                  style={{
                    padding: 10,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  className="gridItem"
                  onMouseDown={(e) =>
                    navigate("/admin/settings/integrations/google-analytics")
                  }
                >
                  <div className="iconDiv">
                    <Icon
                      source={ChartVerticalFilledIcon}
                      style={{ margin: "0 5px" }}
                      color="subdued"
                    ></Icon>
                  </div>
                  <div style={{ flexDirection: "column", marginLeft: "10" }}>
                    <div className="titleDev">
                      <Text variant="bodyMd" as="p" fontWeight="regular">
                        Google Analytics
                      </Text>
                    </div>
                    <div className="description">
                      {/* <Text variant="bodyMd" as="p" fontWeight="regular">
                      SEO Image
                    </Text> */}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Page>
    )
  );
};
export default GridView;
